import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import * as styles from "./PopupWrapper-tw-styles"
import useScreenSize from "../../../hooks/useScreenSize"

const PopupWrapper = props => {
  const { children, variant, closeOnBodyclick } = props
  const style = styles[variant] || styles.defaultStyle

  const [showModal, setShowModal] = useState(false)
  const [modalDoc, setModalDoc] = useState(null)

  const closeModal = () => {
    document.dispatchEvent(new Event("close_newsletter_modal"))
    setShowModal(false)
  }
  const screen = useScreenSize()

  useEffect(() => {
    let modalTimeout
    const path = location?.pathname || ""

    if (
      (path === "/" || path === "/es/" || path === "/es" || path === "/pt/" || path === "/pt") &&
          !location.href.includes("newsletter")
      ) {
          modalTimeout = setTimeout(() => {
              setShowModal(true)
          }, 1)
      }

      return () => {
          if (modalTimeout) {
              clearTimeout(modalTimeout)
          }
      }
  }, [])

  const handleCloseOnKeyPress = event => {
    if (event.key === "Escape" || event.key === "Esc") {
      close()
    }
  }
  const onClick = () => {
    if (closeOnBodyclick) {
      close()
    }
  }

  const close = () => {
    closeModal()
  }

  useEffect(() => {
    setModalDoc(document.getElementById("base-modal"))
    document.addEventListener("keydown", handleCloseOnKeyPress)
    return () => {
      document.removeEventListener("keydown", handleCloseOnKeyPress)
    }
  }, [])

  const modal = showModal ? (
      <div className={style?.wrapper} onClick={onClick}>
          <div className={style?.gap}>
              <div className={style?.container}>
                  <div className={style?.content}>
                      <a href={location.pathname.startsWith("/pt") ? "https://www.passatempo.royalcontigo.com/": "https://www.promo.royalcontigo.com/"} target="_blank" rel="noreferrer">
                          <img
                              src={
                                  screen?.isMobile
                                      ? location.pathname.startsWith("/pt")
                                          ? "https://images.ctfassets.net/gfxilcou9ltt/2HvvsUuztaVS6XO687eetK/fae5da39bcdca5af4c5f6f4a63275370/New_Banner_Mobile_375x520px_PT.png"
                                          : "https://images.ctfassets.net/gfxilcou9ltt/OkTuc1dIv1JvzO4uoRR2i/16916010f8f2e64c17bb55c3bfe709b5/BannerPopup-375x520.png"
                                      : location.pathname.startsWith("/pt")
                                      ? "https://images.ctfassets.net/gfxilcou9ltt/7nGaob95rZKTTVaTPV6K26/9940825f4e4346828c129d3887557a7e/New_Banner_Destok_1440x720_PT.png"
                                      : "https://images.ctfassets.net/gfxilcou9ltt/21Ru6OxZGlX0a8tnKEcd2c/6506d75ba56bf46828592424b16990af/BannerPopup-1440x720.png"
                              }
                          />
                      </a>
                      <button className="modal-close" onClick={close} aria-label="Close" />
                  </div>
              </div>
          </div>
      </div>
  ) : null

  return modalDoc ? ReactDOM.createPortal(modal, modalDoc) : null
}

PopupWrapper.propTypes = {
    closeModal: PropTypes.func,
    children: PropTypes.any,
    variant: PropTypes.string,
    closeOnBodyclick: PropTypes.bool,
}

export default PopupWrapper
